var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 320",
    style: {
      enableBackground: "new 0 0 320 320"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#20AF57",
    d: "M320,274v3c0,4-1,8-2,11c-2,4-4,7-6,10c-3,2-6,4-10,6c-3,1-7,2-11,2h-40c-4,0-7-1-11-2l-9-6c-3-3-5-6-6-9 s-2-6-2-9c-1-3-1-6-1-9c1-3,1-6,1-9s0-5-1-7c0-3-1-5-3-6c-2-2-5-4-8-4H109c-3,0-6,2-8,4c-2,1-3,3-3,6c-1,2-1,4-1,7s0,6,1,9 c0,3,0,6-1,9c0,3-1,6-2,9s-3,6-6,9l-9,6c-4,1-7,2-11,2H29c-4,0-8-1-11-2c-4-2-7-4-10-6c-2-3-4-6-6-10c-1-3-2-7-2-11v-2v-18 c0-5,1-10,2-15c2-5,4-10,6-14c3-5,7-10,12-15c8-7,17-14,27-20c11-5,22-10,34-14c13-4,25-6,39-8c13-2,27-3,41-3c13,0,27,1,40,3 c14,2,27,5,39,9c12,3,23,8,33,14c11,5,19,12,27,19c5,6,9,10,12,15c2,4,4,9,6,14c1,4,2,9,2,15V274z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125,72l-15-14l50-50l50,50l-15,14l-25-26v93h-20V46L125,72z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswer);
export default __webpack_public_path__ + "static/media/answer.16f340f5.svg";
export { ForwardRef as ReactComponent };